import CategoryDropdown from './CategoryDropdown';
import CategoryGrid from './CategoryGrid';

export default function CategoriesSection() {
  return (
    <section className="w-full py-14 md:py-20 px-6 md:px-10 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-3">
            Explore Sugargoo Product Categories
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto mb-8">
            Browse our complete collection of curated Sugargoo finds across every product category.
          </p>
          <CategoryDropdown />
        </div>

        <CategoryGrid />

        <div className="text-center mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-sm hover:bg-primary-600 transition-all duration-200 cursor-pointer whitespace-nowrap"
          >
            Browse All Categories
            <i className="ri-arrow-right-up-line w-4 h-4 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}